import {DateRange} from "react-day-picker";

import {DatePickerMode, DatePickerValue, SplitModeRole} from "@/components/datePicker/DatePicker.types.ts";
import {DatePickerPopoverSingleDateInput} from "@/components/datePicker/subComponents/DatePickerPopoverSingleDateInput/DatePickerPopoverSingleDateInput.tsx";
import {DatePickerPopoverSingleDateRangeInput} from "@/components/datePicker/subComponents/DatePickerPopoverSingleDateRangeInput/DatePickerPopoverSingleDateRangeInput.tsx";
import {StandardDateRange} from "@/lib/queries/reports.ts";
import {DateFormatName, TimeFormatName} from "@/lib/types/common.ts";

type DatePickerPopoverInputBaseProps = {
  name?: string;
  timezone: string;
  dateFormat?: DateFormatName;
  timeFormat?: TimeFormatName;
  splitRole?: SplitModeRole;
};

type DatePickerPopoverInputProps<Mode extends DatePickerMode> = DatePickerPopoverInputBaseProps & {
  mode: Mode;
  selected?: DatePickerValue<Mode>;
  setSelectedAndOnChange: (value: DatePickerValue<Mode>, fixedRange?: StandardDateRange) => void;
};

export const DatePickerPopoverInput = <Mode extends DatePickerMode = "range">({
  mode,
  name,
  timezone,
  selected,
  dateFormat,
  timeFormat,
  splitRole,
  setSelectedAndOnChange,
}: DatePickerPopoverInputProps<Mode>) => {
  return (
    <div className={"d-flex gap-2"}>
      {mode === "range" || mode === "split" ? (
        <>
          <DatePickerPopoverSingleDateRangeInput
            name={`${name}-start`}
            type={"start"}
            timezone={timezone}
            dateRange={selected as DateRange}
            dateFormat={dateFormat}
            mode={mode}
            splitRole={splitRole}
            onChange={(e) => {
              if (e) {
                setSelectedAndOnChange(e as DatePickerValue<Mode>, undefined);
              }
            }}
          />
          <DatePickerPopoverSingleDateRangeInput
            name={`${name}-end`}
            type={"end"}
            timezone={timezone}
            dateRange={selected as DateRange}
            dateFormat={dateFormat}
            mode={mode}
            splitRole={splitRole}
            onChange={(e) => {
              if (e) {
                setSelectedAndOnChange(e as DatePickerValue<Mode>, undefined);
              }
            }}
          />
        </>
      ) : (
        <DatePickerPopoverSingleDateInput
          name={`${name}-single`}
          initialDate={selected as Date}
          timezone={timezone}
          dateFormat={dateFormat}
          timeFormat={timeFormat}
          placeholder={"Select Date"}
          onChange={(dateString, date) => {
            if (!dateString) {
              setSelectedAndOnChange(undefined);
              return;
            }
            setSelectedAndOnChange(date as DatePickerValue<Mode>);
          }}
        />
      )}
    </div>
  );
};
